module.exports = __webpack_public_path__ + "static/media/wrapSecondBg.f9ffdb1d.png";